<app-breadcrumb [title]="'Vacant Post'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header">
          <div class="d-flex justify-content-end">
            <a [routerLink]="['/region/sanctioned-posts/vacant-posts/new']" class="btn btn-primary rounded-0">New
              Vacant Post</a>
          </div>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.stateId" #stateId="ngModel"
                (change)="getDistricts($event.target.value)">
                <option value="" selected>--SELECT STATE--</option>
                <option *ngFor="let item of states" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.districtId" #districtId="ngModel"
                (change)="getSchools($event.target.value)">
                <option value="" selected>--SELECT DISTRICT--</option>
                <option *ngFor="let item of districts" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.schoolId" #schoolId="ngModel">
                <option value="" selected>--SELECT SCHOOL--</option>
                <option *ngFor="let item of schools" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.designationId" #designationId="ngModel">
                <option value="" selected>--SELECT DESIGNATION--</option>
                <option *ngFor="let item of designations" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.financialYearId" #financialYearId="ngModel">
                <option value="" selected>--SELECT FINANCIALYEAR--</option>
                <option *ngFor="let item of financialYears" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-success" (click)="filter()">Search</button>
              <button type="button" class="btn btn-warning ml-2" (click)="export()">Export</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table align-items-center table-hover">
              <colgroup>
                <col style="width: 5%">
                <col style="width: 10%">
                <col style="width: 10%">
                <col style="width: 12%">
                <col style="width: 8%">
                <col style="width: 10%">
                <col style="width: 15%">
                <col style="width: 5%">
                <!-- <col style="width: 10%"> -->
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i-bs *ngIf="query.sort === c.key"
                            [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'" width="1em" height="1em">
                          </i-bs>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of queryResult.items; let i=index;">
                  <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                  <td>{{ v.sanctionedPost?.school?.name }}</td>
                  <td>{{ v.sanctionedPost?.designation?.name }}</td>
                  <td>{{ v.vacancyType?.name }}</td>
                  <td>{{ v.noOfPost }}</td>
                  <td>{{ v.transferCategory?.name }}</td>
                  <td>
                    <a *ngIf="v.document?.mediaUrl" target="_blank" [href]="v.document?.mediaUrl"
                      class="btn btn-success">
                      <span class="mr-2">
                        <i-bs name="check2-circle" width="1em" height="1em"></i-bs>
                      </span>
                      View Certificate
                    </a>
                  </td>
                  <td>
                    <a class="btn btn-sm" [routerLink]="['/region/sanctioned-posts/vacant-posts/edit', v.id]"  [queryParams]="{ page: query.page }">
                      <i-bs name="pencil-square" width="1em" height="1em"></i-bs>
                    </a>
                  </td>
                  <!-- <td><button type="button" (click)="delete(v.id)" class="btn btn-danger rounded-0">Delete</button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</div>